import { Directive, HostListener, Input, ElementRef, OnChanges, SimpleChanges } from '@angular/core';
import { NgControl, FormGroup } from '@angular/forms';
/** SSN Directive */
@Directive({
	selector: '[appMaskSSN]',
})
export class SsnMaskDirective implements OnChanges {
	/** Form group which contain SSN */
	@Input() ssnFormGroup: FormGroup;
	/** Control Name of SSN field */
	@Input() ssnControlName: string;
	/** flag denote whether to show or hide SSN value on field */
	@Input() ShowSSNValue = false;
	/** flag to denote clear the SSN value forcefully */
	@Input() clearValue = false;
	/** isSimplified */
	@Input() isSimplified = false;
	/** */
	value = '';
	/**
	 * SSN Directive Constructor
	 * @param model - Model
	 * @param inputRef - Element ref
	 */
	constructor(
		public model: NgControl,
		private inputRef: ElementRef
	) {}

	/**
	 * Changes on the component
	 * @param changes - Simple changes
	 */
	ngOnChanges(changes: SimpleChanges) {
		if (changes.ShowSSNValue && !this.isSimplified) {
			this.showHideSSN(changes.ShowSSNValue.currentValue);
		}
		if (changes.clearValue) {
			this.value = '';
		}
		if (this.isSimplified) {
			this.maskCellPhoneNo(this.inputRef.nativeElement.value);
		}
	}

	/**
	 * Host listener to track keyup
	 * @param event - Keyup Event
	 */
	@HostListener('keyup', ['$event']) onClick(event: any) {
		let isBackspace = false;
		if (event.key === 'Backspace' || event.key === 'Delete' || event.key === 'Del') {
			isBackspace = true;
		}
		if (!this.isSimplified) {
			this.onInputChange(event, isBackspace);
		}
	}
	/**
	 * Handling SSN Masking
	 * @param event - keyup event
	 * @param backspace - backspace
	 */
	onInputChange(event: any, backspace: boolean) {
		let eventValue: string = event.target.value.slice(-1);
		eventValue = eventValue.replace(/\D/g, '');
		if (eventValue.length > 0) {
			eventValue = eventValue[eventValue.length - 1];
		}
		eventValue = this.value + eventValue;
		eventValue = eventValue.substr(0, 9);
		let newVal = eventValue;
		// newVal = newVal.replace(/^(\d{3})(\d{2})(\d{4})$/g, '$1-$2-$3');
		newVal = this.formatSSN(newVal);
		if (!this.ShowSSNValue) {
			if (newVal.length <= 5) {
				newVal = newVal.replace(/[0-9]/g, 'X');
			} else {
				let p = newVal.substr(0, 7);
				p = p.replace(/[0-9]/g, 'X');
				newVal = p + newVal.substr(7, 4);
			}
		}

		const elRef = this.inputRef.nativeElement;
		// const orVal = elRef.getAttribute('data-model-value') || '';
		elRef.value = newVal;
		/** Set `data-model-value` attribute to the actual value of SSN */
		elRef?.setAttribute('data-model-value', eventValue);

		if (backspace) {
			newVal = '';
			this.value = '';
			eventValue = '';
			elRef.value = '';
		}

		this.value = eventValue;
		/** update control value without changing the modelValue */
		this.ssnFormGroup.get(this.ssnControlName).setValue(this.value, {
			emitEvent: false,
			emitModelToViewChange: false,
		});
	}

	/** Format SSN Value in a way XXX-XX-XXXX */
	formatSSN(value: string) {
		if (value.length >= 3 && value.length < 6) {
			value = value.substr(0, 3) + '-' + value.substr(3, value.length);
		} else if (value.length >= 6) {
			value = value.substr(0, 3) + '-' + value.substr(3, 2) + '-' + value.substr(5, 4);
		}
		return value;
	}

	/**
	 * Masking the SSN value with 'X'
	 * @param newVal
	 */
	maskSSN(newVal) {
		if (newVal.length <= 5) {
			newVal = newVal.replace(/[0-9]/g, 'X');
		} else {
			let p = newVal.substr(0, 7);
			p = p.replace(/[0-9]/g, 'X');
			newVal = p + newVal.substr(7, 4);
		}
		const elRef = this.inputRef.nativeElement;
		elRef.value = newVal;
	}

	/** Toggle SSN */
	showHideSSN(showSSN) {
		const elRef = this.inputRef.nativeElement;
		if (!showSSN) {
			this.maskSSN(elRef.value);
		} else {
			const newVal = this.formatSSN(this.ssnFormGroup.get(this.ssnControlName).value);
			elRef.value = newVal;
		}
	}

	/** Mask cell phone number */
	maskCellPhoneNo(number) {
		let cellPhone = '';
		(number as string).split('.').forEach(num => {
			cellPhone += num;
		});
		if (cellPhone.length <= 5) {
			cellPhone = cellPhone.replace(/[0-9]/g, 'X');
		} else {
			let p = cellPhone.substr(0, 3) + '.' + cellPhone.substr(3, 3);
			p = p.replace(/[0-9]/g, 'X');
			cellPhone = p + '.' + cellPhone.substr(6, 5);
		}
		const elRef = this.inputRef.nativeElement;
		elRef.value = cellPhone;
	}
}
